/**
 * Hol futunk, es hogyan hitelesitunk?
 *
 * Ket kornyezet van, es egyetlen kulonbseg koztuk:
 *
 *  - **Bongeszo / PWA**: az API azonos originen van (fejleszteskor Vite proxy,
 *    elesben Caddy). A session httpOnly sutiben, amit a JS nem lat - ez a
 *    biztonsagosabb valtozat, ezert marad ez az alapertelmezes.
 *
 *  - **Desktop (Tauri)**: a felulet a gepen levo fajlokbol tolt be, tehat az
 *    API mindig MASIK origin. Suti igy nem hasznalhato, ezert Bearer tokent
 *    kuldunk, amit a rendszer-bongeszos belepes vegen kapunk (lasd
 *    `apps/server/src/modules/auth/desktop.ts`).
 *
 * Minden halozati hivas ezen a ket fuggvenyen (`apiBase`, `authHeaders`)
 * keresztul megy, igy a kulonbseg egyetlen helyen van kezelve.
 */

const TOKEN_KEY = 'avslack.desktop.token';

interface TauriWindow {
  __TAURI_INTERNALS__?: unknown;
}

/** Tauri ablakban futunk-e? A Tauri ezt a globalis objektumot injektalja. */
export const isDesktop = (): boolean =>
  typeof window !== 'undefined' && (window as TauriWindow).__TAURI_INTERNALS__ !== undefined;

/**
 * A felulet valodi web-originrol jott-e?
 *
 * Az asztali app a szerverrol tolti a feluletet, nem beepitett fajlokbol -
 * igy a webes javitasok uj telepito nelkul is megerkeznek. Ilyenkor az app
 * AZONOS ORIGINEN van a szerverrel, tehat a relativ ut es a suti a helyes,
 * ugyanugy, mint a bongeszoben.
 *
 * A `file://` es a `tauri://` az egyetlen eset, ahol ez nem igaz - ott kell a
 * teljes cim es a Bearer token.
 */
export const isSameOriginApp = (): boolean =>
  typeof window !== 'undefined' && /^https?:$/.test(window.location.protocol);

/**
 * Az API alapcime.
 *
 * Ures, ha a felulet valodi originrol jott (bongeszo VAGY tavolrol toltott
 * asztali app). Csak helyi fajlbol betoltott feluletnel kell teljes cim.
 */
export function apiBase(): string {
  if (isSameOriginApp()) return '';
  const configured = import.meta.env.VITE_AVSLACK_SERVER_URL as string | undefined;
  return (configured ?? 'http://localhost:8000').replace(/\/$/, '');
}

export function getDesktopToken(): string | null {
  if (!isDesktop()) return null;
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setDesktopToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // A tarolas hianya nem torheti el a belepest - a session igy a
    // futo peldany elettartamaig el.
  }
}

/** A hitelesito fejlec - bongeszoben ures, mert ott a suti dolgozik. */
export function authHeaders(): Record<string, string> {
  const token = getDesktopToken();
  return token ? { authorization: `Bearer ${token}` } : {};
}
